import React from 'react';

import { Calculator } from '@/components/Template/Template5/Calculator';
import { VouchersCarrousel } from '@/components/Template/Template5/VouchersCarrousel';

import {
  TRecommendation,
  TCalculator,
  TVoucher,
} from '@/services/requests/Recommendation/types/template5';

type TProps = {
  data: TRecommendation;
};

export const CardLeft = ({ data }: TProps) => {
  const { id, component } = data;
  return component.type === '["miles_calculator"]' ? (
    <Calculator id={id} component={component as TCalculator} />
  ) : (
    <VouchersCarrousel id={id} component={component as TVoucher} />
  );
};
